const initToggler = () => {


    $('.profile-menu-dropdown-toggler').click(function () {
        $(this).next().slideToggle();
        $(this).closest('profile-menu-dropdown').toggleClass('opened');
    });
        
};

export {
    initToggler
};
